import { render, staticRenderFns } from "./MailServiceList.vue?vue&type=template&id=8916cb4e"
import script from "./MailServiceList.vue?vue&type=script&lang=js"
export * from "./MailServiceList.vue?vue&type=script&lang=js"
import style0 from "./MailServiceList.vue?vue&type=style&index=0&id=8916cb4e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports